import { estApiError } from '../api/errors.js';
import { retourSur } from './retour.js';

/**
 * Conditions générales d'utilisation (ARTO-59) côté régie : l'aiguillage vers
 * `/app/conditions`. L'API décide — `/auth/me` porte `cguAcceptationRequise`
 * tant que le compte n'a pas accepté. Ce que la régie en tire (chargeurs,
 * annonce en cours d'usage, repli hors ligne) est commun à tout confinement :
 * `auth/confinement.ts`.
 */

/** `/app/conditions?retour=…`, le retour assaini comme partout (`auth/retour.ts`). */
export function cheminConditions(retour: string): string {
  return `/app/conditions?retour=${encodeURIComponent(retourSur(retour))}`;
}

/** Le refus de l'API pour une session tenue d'accepter les CGU. */
export function estRefusCgu(erreur: unknown): boolean {
  if (!estApiError(erreur) || erreur.status !== 403) return false;
  return (erreur.details as { raison?: unknown } | null)?.raison === 'cgu_acceptation_requise';
}
